import { z } from 'zod';

export const coverShipmentStatusValues = ['ACTIVE', 'VOIDED'] as const;
export type CoverShipmentStatus = (typeof coverShipmentStatusValues)[number];
export const CoverShipmentStatusSchema: z.ZodType<CoverShipmentStatus> = z.enum(
  coverShipmentStatusValues,
);
